import { storage } from './storage.js';
import { catalog } from './catalog.js';
import { hasOrder } from './order-core.js';

/* Orden propio de las hileras y de los canales, por sección (live, vod, series), proveedor y espectador (como los filtros). */

const KEY = 'customOrder';
const MAX_USERS = 30;

export const customOrder = {
    get(section) {
        const all = storage.get(KEY, {}) || {};
        const mine = all[catalog.userKey] || {};
        return mine[section] || {};
    },

    set(section, patch) {
        const all = storage.get(KEY, {}) || {};
        const key = catalog.userKey;
        const mine = Object.assign({}, all[key]);
        const cur = Object.assign({}, mine[section]);
        if (patch.chans) cur.chans = Object.assign({}, cur.chans, patch.chans);
        if (patch.cats) cur.cats = patch.cats;
        mine[section] = cur;
        mine.updated = Date.now();
        all[key] = mine;
        const keys = Object.keys(all);
        if (keys.length > MAX_USERS) keys.sort((a, b) => (all[a].updated || 0) - (all[b].updated || 0)).slice(0, keys.length - MAX_USERS).forEach((k) => delete all[k]);
        storage.set(KEY, all);
    },

    reset(section) {
        const all = storage.get(KEY, {}) || {};
        const mine = all[catalog.userKey];
        if (!mine || !mine[section]) return;
        delete mine[section];
        storage.set(KEY, all);
    },

    has(section) { return hasOrder(this.get(section)); }
};
